<template>
    <BaseSection v-if="guidelines.length || pending">
        <template #title>
            <h2>Guidelines</h2>
        </template>

        <BaseGuidelineCards
            :cards="guidelineCards"
            :is-loading="pending"
        />
    </BaseSection>
</template>

<script setup>
import guidelinesByTopicsQuery from '~/graphql/queries/guidelines/byTopic.graphql';

const { variables } = useCraftGraphql();
const { activeSite } = useMultisite();

if (activeSite.value?.handle) {
    variables.site = activeSite.value?.handle;
}

if (useRoute().params.slug) {
    variables.slug = useRoute().params.slug;
}

const response = await useLazyAsyncQuery({
    query: guidelinesByTopicsQuery,
    variables
});

const { data: entry, pending } = response;

const guidelines = computed(() => {
    if (!entry.value?.guidelines) {
        return [];
    }

    return entry.value.guidelines;
});

const guidelineCards = computed(() => {
    return guidelines.value.map((guideline) => {
        return {
            title: guideline.title,
            url: '/' + guideline.uri,
        };
    });
});
</script>
